module.exports = __webpack_public_path__ + "static/media/say_algorithm.ca596b55.png";